import { loadBrandConfig } from './loadBrandConfig'

/**
 * 阅读器路由名称（构建时确定）
 * - novelarc: chapter-scroll（无限滚动）
 * - talewave: chapter-scroll（无限滚动）
 * - 其他品牌: chapter（翻页）
 */
export const READER_ROUTE_NAME = loadBrandConfig({
  rocnovel: 'chapter',
  oceread: 'chapter',
  ficmoon: 'chapter',
  novelarc: 'chapter-scroll',
  storyella: 'chapter-scroll',
  silktale: 'chapter-scroll',
  pearla: 'chapter-scroll',
  fictora: 'chapter',
  marinovel: 'chapter',
  talewave: 'chapter-scroll',
  flipnovel: 'chapter-scroll',
  moonpage: 'chapter-scroll',
  storlyn: 'chapter-scroll',
  novaris: 'chapter-scroll',
}) as 'chapter' | 'chapter-scroll'
